<template>
	<div :class="selfPrefix">
		<div class="cls-block">
			<section-title :text="text" :btn="{text:'浏览全部案例',center:true,router:'https://jzt.jd.com/static/yxy-jqsz/5'}"/>
			<div class="cls-main">
				<j-carousel
                    :height="446" :autoplay="true" :loop="true" :autoplay-speed="2700" arrow="never" :indicatorStyle="{left: '170px', bottom: '-15px'}" subActiveColor="#3247FF">
                    <j-carousel-item v-for="(item, index) in excellentData"
                    :key="index">
                        <div class="carousel-item-wrap">
                            <img :src="item.img" width="1203" height="446"/>
                            <div class="introduce-block">
                                <div class="introduce-block-title" >{{ item.title }}</div>
                                <div class="introduce-block-content">
                                  <div><b class="introduce-block-content-b">{{ item.contentTitle }}</b>{{ item.contentMess }}</div>
                                  <b class="introduce-block-array">{{ item.CTitle }}</b>
                                  <div v-for="(cit, index) in item.CArray" :key="index">{{ cit }}</div>
                                </div>
                                <div class="introduce-block-footer">
                                    <div v-for="(up, index) in (item.footer || [])"
                                        :key="index"
                                        class="flex-center"
                                        :class="{'ml30': index != 0}"
                                    >
                                        <div>
                                            <div style="font-size: 14px; font-weight: 500">{{ up.key }}</div>
                                            <div style="white-space: nowrap;">
                                                <span style="font-size: 40px; font-family: Bebas;">{{ up.value }}</span>
                                            </div>
                                        </div>
                                            <img src="//storage.360buyimg.com/ui2code/preview/excellentCaseUpIcon.png" class="ml8" width="40"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </j-carousel-item>
              </j-carousel>
			</div>
		</div>
	</div>
</template>

<script>
import sectionTitle from "./sectionTitle";
export default {
  name: "ProductExcellentCase",
  props: {
    pageKey: {
      type: String,
      default: ''
    },
    excellentData: {
      type: Array,
      default() {
        return [];
      }
    },
    text:{
      type: String,
      default: ''
    }
  },
  components: {
    sectionTitle
  },
  data() {
    return {
      prefixCls: "jad-block"
    };
  },
  computed: {
    selfPrefix() {
      return `${this.prefixCls}-product-excellent-case`;
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ .jad-carousel-indicator .jad-carousel-indicator-item{
    width: 110px !important;
    height: 11px !important;
    background: #D2D2D2;
    opacity: 1;
}
.jad-block-product-excellent-case {
  height: 100%;
  margin-top: 0px;
  padding: 86px 0 90px 0;
  background: linear-gradient(180deg, #f0f2ff 0%, #fbfcff 48.13%, white 100%);
  .cls-block {
    width: 100%;
    .cls-router{
      display: block;
      text-align: center;
      color: #e12419;
      margin-top: 5px;
      font-weight: 500;
    }
    .cls-main {
      margin: 0 auto;
      width: 1203px;
      margin-top: 36px;
      .jad-carousel {
        overflow: hidden;
        .jad-carousel-item {
            background-color: white;
        }
        .jad-carousel-indicator-item {
            width: 60px;
            height: 4px;
            background: #E2E2E2;
            opacity: 1;
        }
        .carousel-item-wrap {
            position: relative;
            .flex-center {
                display: flex;
                align-items: center;
            }
            .ml8 {
                margin-left: 8px;
            }
            .ml30 {
                margin-left:30px;
            }
            .introduce-block {
                position: absolute;
                top: 94px;
                right: 22px;
                color: white;
                width: 340px;
                text-align: left;
                &-title {
                    font-size: 24px;
                    font-weight: 500;
                    color: rgba(255,255,255,1);
                }
                &-content {
                    margin-top: 16px;
                    font-size: 14px;
                    font-weight: normal;
                    color: rgba(255,255,255,1);
                    text-align: justify;
                    &-b {
                      margin-right: 5px;
                  }
                }
                &-array{
                  display: block;
                  margin-top: 5px;
                }
                &-footer {
                    margin-top: 32px;
                    display: flex;

                }
            }
        }
    }
    }
  }
}
</style>
